var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "div",
        {
          staticClass: "pad30-lr min-height",
          class: { "seller-style": _vm.type != "buyer" }
        },
        [
          _vm._m(0),
          _c(
            "div",
            {
              staticClass:
                "flex flex-item1 pad20-tb text-center justify-around status"
            },
            _vm._l(_vm.afterSalesNodeList, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "item flex flex-column relative items-center f15"
                },
                [
                  _c("div", { staticClass: "line" }),
                  _c("div", {
                    staticClass:
                      "iconfont f36 radius100 mar20-b flex justify-center items-center white",
                    class: item.frontClass
                  }),
                  _c("div", [_vm._v(_vm._s(item.desc))])
                ]
              )
            }),
            0
          ),
          _c(
            "el-descriptions",
            { staticClass: "pad20 border", attrs: { title: "订单信息" } },
            [
              _c("el-descriptions-item", { attrs: { label: "订单编号" } }, [
                _c("div", { staticClass: "flex" }, [
                  _c("div", [_vm._v(_vm._s(_vm.detail.orderId))]),
                  _c(
                    "a",
                    {
                      staticClass: "blue mar15-l pointer",
                      attrs: {
                        target: "_blank",
                        href:
                          _vm.type == "buyer"
                            ? "/v/order/detail/" + _vm.detail.orderId
                            : "/v/order/detailSeller/" + _vm.detail.orderId
                      }
                    },
                    [_vm._v("查看")]
                  )
                ])
              ]),
              _c("el-descriptions-item", { attrs: { label: "订单状态" } }, [
                _vm._v(_vm._s(_vm.detail.refundStatusCn))
              ]),
              _vm.selfOperatedShop && _vm.detail.suppShopName
                ? _c(
                    "el-descriptions-item",
                    { attrs: { label: "关联采购单编号" } },
                    _vm._l(_vm.detail.suppOrderIdList, function(suppOrderId) {
                      return _c(
                        "a",
                        {
                          key: suppOrderId,
                          staticClass: "blue pointer",
                          attrs: {
                            target: "_blank",
                            href: "/v/order/detail/" + suppOrderId
                          }
                        },
                        [_vm._v(_vm._s(suppOrderId))]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm.selfOperatedShop && _vm.detail.suppShopName
                ? _c(
                    "el-descriptions-item",
                    { attrs: { label: "供应商店铺" } },
                    [_vm._v(_vm._s(_vm.detail.suppShopName))]
                  )
                : _vm._e(),
              _c("el-descriptions-item", { attrs: { label: "收货人姓名" } }, [
                _vm._v(_vm._s(_vm.detail.linkman || _vm.detail.applyName))
              ]),
              _c("el-descriptions-item", { attrs: { label: "收货人电话" } }, [
                _vm._v(_vm._s(_vm.detail.tel || _vm.detail.applyPhone))
              ]),
              _c("el-descriptions-item", { attrs: { label: "订单金额" } }, [
                _vm._v(_vm._s(_vm.detail.applyAmount) + "元")
              ]),
              _c("el-descriptions-item", { attrs: { label: "支付方式" } }, [
                _vm._v(_vm._s(_vm.detail.refundName))
              ]),
              _c("el-descriptions-item", { attrs: { label: "售后快递单号" } }, [
                _vm._v(_vm._s(_vm.detail.logisticsNum))
              ])
            ],
            1
          ),
          _c(
            "el-descriptions",
            {
              staticClass: "pad20 mar20-tb border",
              attrs: { labelClassName: "nowrap" }
            },
            [
              _c("template", { slot: "title" }, [
                _vm.detail.refundStatus == 1
                  ? _c("div", [
                      _vm._v("退款成功"),
                      _vm.detail.realAmount
                        ? _c(
                            "span",
                            { staticClass: "f13 gray6 pad10-l fb-normal" },
                            [_vm._v("钱已打至买家账户")]
                          )
                        : _vm._e()
                    ])
                  : _c("div", { staticClass: "flex items-center" }, [
                      _c("div", { staticClass: "pad20-r" }, [
                        _vm._v("退款申请")
                      ]),
                      _vm.type != "buyer"
                        ? _c(
                            "div",
                            { staticClass: "f13 mar2-t fb-normal gray6" },
                            [_vm._v("买家申请退款，请您尽快处理")]
                          )
                        : _vm._e(),
                      _vm.timeDown
                        ? _c(
                            "div",
                            { staticClass: "f13 mar2-t fb-normal red pad10-l" },
                            [
                              _c("span", { staticClass: "pad5-r" }, [
                                _vm._v(_vm._s(_vm.timeDown))
                              ]),
                              _vm._v(
                                "后您若未处理，系统将自动退款给买家\n        "
                              )
                            ]
                          )
                        : _vm._e()
                    ])
              ]),
              _c("el-descriptions-item", { attrs: { label: "申请人" } }, [
                _vm._v("\n      " + _vm._s(_vm.detail.applyName)),
                _c("span", { staticClass: "pad15-l" }, [
                  _vm._v(_vm._s(_vm.detail.applyPhone))
                ])
              ]),
              _c("el-descriptions-item", { attrs: { label: "申请时间" } }, [
                _vm._v(_vm._s(_vm.detail.applyTime))
              ]),
              _c("el-descriptions-item", { attrs: { label: "退款原因" } }, [
                _vm._v(_vm._s(_vm.detail.refundCaseStr))
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "退款金额" } },
                [
                  _vm.priceEdit && _vm.detail.refundStatus == 5
                    ? _c(
                        "div",
                        { staticClass: "flex items-center" },
                        [
                          _c("el-input", {
                            attrs: { size: "mini", placeholder: "请输入内容" },
                            model: {
                              value: _vm.price,
                              callback: function($$v) {
                                _vm.price = $$v
                              },
                              expression: "price"
                            }
                          }),
                          _c(
                            "el-button",
                            {
                              staticClass: "mar5-lr",
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.priceConfirm }
                            },
                            [_vm._v("确定")]
                          ),
                          _c("div", [_vm._v("元")])
                        ],
                        1
                      )
                    : [
                        _vm._v(
                          "\n        " + _vm._s(_vm.price) + "元\n        "
                        ),
                        _vm.detail.refundStatus == 5 &&
                        _vm.detail.isSupportPartialRefund
                          ? _c(
                              "span",
                              {
                                staticClass: "blue mar5-l pointer",
                                on: {
                                  click: function($event) {
                                    _vm.priceEdit = true
                                  }
                                }
                              },
                              [_vm._v("修改")]
                            )
                          : _vm._e()
                      ]
                ],
                2
              ),
              _vm.detail.refundStatus == 1
                ? [
                    _c(
                      "el-descriptions-item",
                      { attrs: { label: "退款类型" } },
                      [_vm._v(_vm._s(_vm.detail.refundTypeCn))]
                    ),
                    _c(
                      "el-descriptions-item",
                      { attrs: { label: "买家退款说明" } },
                      [_vm._v(_vm._s(_vm.detail.refundDesc))]
                    ),
                    _c(
                      "el-descriptions-item",
                      { attrs: { label: "退款时间" } },
                      [_vm._v(_vm._s(_vm.detail.finishTime))]
                    ),
                    _c(
                      "el-descriptions-item",
                      { attrs: { span: 3, label: "凭证" } },
                      [
                        _vm.detail.buyerImgs && _vm.detail.buyerImgs.length
                          ? _c(
                              "div",
                              { staticClass: "flex flex-wrap" },
                              _vm._l(_vm.detail.buyerImgs, function(
                                item,
                                index
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass:
                                      "wh100 mar10-r mar10-b overflow"
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: item + "?imageView2/1/w/100/h/100"
                                      }
                                    })
                                  ]
                                )
                              }),
                              0
                            )
                          : [_vm._v("无")]
                      ],
                      2
                    )
                  ]
                : [
                    _c(
                      "el-descriptions-item",
                      { attrs: { label: "买家退款说明" } },
                      [_vm._v(_vm._s(_vm.detail.refundDesc))]
                    ),
                    _vm.detail.firstTrialDesc
                      ? _c(
                          "el-descriptions-item",
                          { attrs: { span: 2, label: "卖家退款说明" } },
                          [_vm._v(_vm._s(_vm.detail.firstTrialDesc))]
                        )
                      : _vm._e(),
                    _c(
                      "el-descriptions-item",
                      { attrs: { span: 3, label: "凭证" } },
                      [
                        _vm.detail.buyerImgs && _vm.detail.buyerImgs.length
                          ? _c(
                              "div",
                              { staticClass: "flex flex-wrap" },
                              _vm._l(_vm.detail.buyerImgs, function(
                                item,
                                index
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass:
                                      "wh100 mar10-r mar10-b overflow"
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: item + "?imageView2/1/w/100/h/100"
                                      }
                                    })
                                  ]
                                )
                              }),
                              0
                            )
                          : [_vm._v("无")]
                      ],
                      2
                    ),
                    _vm.type != "buyer"
                      ? _c(
                          "el-descriptions-item",
                          { attrs: { span: 2, label: "卖家说明" } },
                          [
                            _c("div", { staticStyle: { width: "900px" } }, [
                              _c(
                                "div",
                                [
                                  _c("el-input", {
                                    attrs: {
                                      rows: "4",
                                      type: "textarea",
                                      placeholder: "请输入内容",
                                      maxlength: "200",
                                      "show-word-limit": ""
                                    },
                                    model: {
                                      value: _vm.firstTrialDesc,
                                      callback: function($$v) {
                                        _vm.firstTrialDesc = $$v
                                      },
                                      expression: "firstTrialDesc"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "mar20-t text-center" },
                                [
                                  _vm.detail.refundStatus == 0
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "mar20-r",
                                          staticStyle: { width: "105px" },
                                          attrs: {
                                            loading: _vm.rejectSubmitLoading
                                          },
                                          on: { click: _vm.rejectSubmit }
                                        },
                                        [_vm._v("驳回")]
                                      )
                                    : _vm._e(),
                                  _vm.detail.refundStatus == 0
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            loading: _vm.agreeSubmitLoading
                                          },
                                          on: { click: _vm.agreeSubmit }
                                        },
                                        [_vm._v("同意售后")]
                                      )
                                    : _vm._e(),
                                  _vm.detail.refundStatus == 5
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            loading: _vm.agreeSubmitLoading
                                          },
                                          on: { click: _vm.backSubmit }
                                        },
                                        [_vm._v("退款")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
            ],
            2
          ),
          _vm.type == "buyer"
            ? _c(
                "div",
                { staticClass: "flex pad20 justify-center" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/aftersales/orderList" } },
                    [
                      _c("el-button", { staticClass: "mar20-r" }, [
                        _vm._v("返回")
                      ])
                    ],
                    1
                  ),
                  _vm.detail.isEnabled
                    ? [
                        _vm.detail.refundStatus == 0
                          ? _c(
                              "el-button",
                              {
                                staticClass: "mar20-r",
                                attrs: {
                                  loading: _vm.cancelApplyLoading,
                                  type: "primary"
                                },
                                on: { click: _vm.cancelApply }
                              },
                              [_vm._v("取消申请")]
                            )
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          _vm.scLink +
                          "order/person/toApplyRefund.do?orderId=" +
                          _vm.detail.orderId
                      }
                    },
                    [
                      _vm.detail.refundStatus == 2 ||
                      _vm.detail.refundStatus == 3
                        ? _c("el-button", { attrs: { type: "primary" } }, [
                            _vm._v("重新申请")
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    : _c("div", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "min-height",
        class: { "seller-style": _vm.type != "buyer" }
      })
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex items-center gray3 pad20-tb border-b mar20-b" },
      [
        _c("div", { staticClass: "f20 fb mar15-r" }, [_vm._v("售后处理")]),
        _c(
          "a",
          {
            staticClass: "flex items-center",
            attrs: {
              target: "_blank",
              href: "https://work.weixin.qq.com/kfid/kfcd200d8c554673e56"
            }
          },
          [
            _c("img", {
              attrs: {
                src:
                  "https://nfs.nxin.com/cms_image_02128766-9b82-470c-b555-b177a4bc8473.png"
              }
            }),
            _c("div", { staticClass: "pad5-l" }, [_vm._v("联系客服")])
          ]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }